import gql from 'graphql-tag';

export const DELETE_MISSION_MUTATION = gql`
  mutation DeleteMission($where: MissionWhereUniqueInput!) {
    deleteMission(where: $where) {
      id
    }
  }
`;
